import { Component, OnInit, Inject, Input, Optional, ViewChild, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import {MatListModule} from '@angular/material/list';
import { FormBuilder, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';

import { AuthService } from '../../services/auth.service';
import { OrganizationService } from '../../services/organization.service';
import { PropertyService } from '../../services/property.service';


@Component({
  selector: 'app-login',
  templateUrl: './createUser.component.html',
  styleUrls: ['./createUser.component.scss']
})
export class CreateUserComponent implements OnInit, AfterViewInit {
  error: string;
  organization = "test";
  userList;
  filteredUserList: any[];
  selectedUsers: any[];
  loading: boolean = true;
  roleList: string[];
  selectedTabIndex = 0;
  properties;
  selectedUser;
  
  // Table properties
  displayedColumns: string[] = ['select', 'name', 'email', 'role', 'property', 'actions'];
  dataSource = new MatTableDataSource<any>();
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  
  // Pagination properties
  totalItems = 0;
  currentPage = 1;
  pageSize = 10;
  
  // Filter properties
  searchFilter: string = '';
  roleFilter: string = '';
  
  // Tab control
  allowTabChange: boolean = false;
  previousTabIndex: number = 0;

  editForm = this.fb.group({
    id: [null],
    firstName: [null, Validators.required],
    lastName: [null, Validators.required],
    email: [null, Validators.required],
    role: [null, Validators.required],
    property: [null],
    password: [null]
  });


  addressForm = this.fb.group({
    firstName: [null, Validators.required],
    lastName: [null, Validators.required],
    email: [null, Validators.required],
    role: [null, Validators.required],
    property: [null],
    password: [null, Validators.compose([
      Validators.required, Validators.minLength(8)])
    ]
  });

  hasUnitNumber = false;

  states = [
    {name: 'Alabama', abbreviation: 'AL'},
    {name: 'Alaska', abbreviation: 'AK'},
    {name: 'American Samoa', abbreviation: 'AS'},
    {name: 'Arizona', abbreviation: 'AZ'},
    {name: 'Arkansas', abbreviation: 'AR'},
    {name: 'California', abbreviation: 'CA'},
    {name: 'Colorado', abbreviation: 'CO'},
    {name: 'Connecticut', abbreviation: 'CT'},
    {name: 'Delaware', abbreviation: 'DE'},
    {name: 'District Of Columbia', abbreviation: 'DC'},
    {name: 'Federated States Of Micronesia', abbreviation: 'FM'},
    {name: 'Florida', abbreviation: 'FL'},
    {name: 'Georgia', abbreviation: 'GA'},
    {name: 'Guam', abbreviation: 'GU'},
    {name: 'Hawaii', abbreviation: 'HI'},
    {name: 'Idaho', abbreviation: 'ID'},
    {name: 'Illinois', abbreviation: 'IL'},
    {name: 'Indiana', abbreviation: 'IN'},
    {name: 'Iowa', abbreviation: 'IA'},
    {name: 'Kansas', abbreviation: 'KS'},
    {name: 'Kentucky', abbreviation: 'KY'},
    {name: 'Louisiana', abbreviation: 'LA'},
    {name: 'Maine', abbreviation: 'ME'},
    {name: 'Marshall Islands', abbreviation: 'MH'},
    {name: 'Maryland', abbreviation: 'MD'},
    {name: 'Massachusetts', abbreviation: 'MA'},
    {name: 'Michigan', abbreviation: 'MI'},
    {name: 'Minnesota', abbreviation: 'MN'},
    {name: 'Mississippi', abbreviation: 'MS'},
    {name: 'Missouri', abbreviation: 'MO'},
    {name: 'Montana', abbreviation: 'MT'},
    {name: 'Nebraska', abbreviation: 'NE'},
    {name: 'Nevada', abbreviation: 'NV'},
    {name: 'New Hampshire', abbreviation: 'NH'},
    {name: 'New Jersey', abbreviation: 'NJ'},
    {name: 'New Mexico', abbreviation: 'NM'},
    {name: 'New York', abbreviation: 'NY'},
    {name: 'North Carolina', abbreviation: 'NC'},
    {name: 'North Dakota', abbreviation: 'ND'},
    {name: 'Northern Mariana Islands', abbreviation: 'MP'},
    {name: 'Ohio', abbreviation: 'OH'},
    {name: 'Oklahoma', abbreviation: 'OK'},
    {name: 'Oregon', abbreviation: 'OR'},
    {name: 'Palau', abbreviation: 'PW'},
    {name: 'Pennsylvania', abbreviation: 'PA'},
    {name: 'Puerto Rico', abbreviation: 'PR'},
    {name: 'Rhode Island', abbreviation: 'RI'},
    {name: 'South Carolina', abbreviation: 'SC'},
    {name: 'South Dakota', abbreviation: 'SD'},
    {name: 'Tennessee', abbreviation: 'TN'},
    {name: 'Texas', abbreviation: 'TX'},
    {name: 'Utah', abbreviation: 'UT'},
    {name: 'Vermont', abbreviation: 'VT'},
    {name: 'Virgin Islands', abbreviation: 'VI'},
    {name: 'Virginia', abbreviation: 'VA'},
    {name: 'Washington', abbreviation: 'WA'},
    {name: 'West Virginia', abbreviation: 'WV'},
    {name: 'Wisconsin', abbreviation: 'WI'},
    {name: 'Wyoming', abbreviation: 'WY'}
  ];

  constructor(private authService: AuthService,
              private orgService: OrganizationService,
              private propertyService: PropertyService,
              private fb: FormBuilder,
              private router: Router) {

    this.orgService.getOrganization().then((org) => {
      this.organization = org;
      this.refreshUsers();
    });
    this.orgService.getUserRoles().then((roles) => {
      this.roleList = roles as string[];
    });

    this.propertyService.getProperties().then((properties) => {
      this.properties = properties;
      this.applyUserProperties();
    });
    
    this.selectedUsers = [];
    this.roleFilter = 'all';
    this.previousTabIndex = 0;
    this.allowTabChange = false;
  }

  ngOnInit() {
  }

  refreshUsers() {
    this.loading = true;
    this.orgService.getUsers(this.organization, this.currentPage, this.pageSize).then((response: any) => {
      this.loading = false;
      
      // Handle paginated response
      if (response && response.data && Array.isArray(response.data)) {
        // IMPORTANT: Replace userList with ONLY the current page's data
        const limitedData = response.data.slice(0, this.pageSize);
        this.userList = limitedData;
        this.totalItems = response.total || 0;
        this.currentPage = response.page || 1;
        this.pageSize = response.pageSize || 10;
      } else {
        // Fallback for non-paginated response
        this.userList = Array.isArray(response) ? response : [];
        this.totalItems = this.userList.length;
      }
      
      this.applyUserProperties();
      this.filteredUserList = [...this.userList];
      this.updateDataSource();
    }).catch((error) => {
      console.error('Error loading users:', error);
      this.loading = false;
      this.userList = [];
      this.filteredUserList = [];
      this.totalItems = 0;
    });
  }
  
  onPageChange(event: any) {
    this.currentPage = event.pageIndex + 1;
    this.pageSize = event.pageSize;
    this.refreshUsers();
  }
  
  updateDataSource() {
    this.dataSource.data = this.filteredUserList || [];
    if (this.sort) {
      this.dataSource.sort = this.sort;
    }
    // Explicitly ensure paginator is NOT connected to dataSource for server-side pagination
    if (this.dataSource.paginator) {
      this.dataSource.paginator = null;
    }
  }
  
  ngAfterViewInit() {
    if (this.sort) {
      this.dataSource.sort = this.sort;
    }
    // Explicitly ensure paginator is NOT connected to dataSource for server-side pagination
    if (this.dataSource.paginator) {
      this.dataSource.paginator = null;
    }
  }
  
  applyFilter() {
    // Reset to first page when filtering (client-side search only on current page)
    // Note: For server-side filtering, we would reset currentPage and call refreshUsers()
    // But since search is client-side, we just filter the current page's data
    let filtered = [...this.userList];
    
    // Apply search filter
    if (this.searchFilter && this.searchFilter.trim()) {
      const searchLower = this.searchFilter.toLowerCase().trim();
      filtered = filtered.filter(user => {
        const fullName = `${user.firstName || ''} ${user.lastName || ''}`.toLowerCase();
        const email = (user.emailAddress || '').toLowerCase();
        const property = (user.property && user.property.addressLine1) ? user.property.addressLine1.toLowerCase() : '';
        return fullName.includes(searchLower) || email.includes(searchLower) || property.includes(searchLower);
      });
    }
    
    // Apply role filter
    if (this.roleFilter && this.roleFilter !== 'all' && this.roleFilter !== '') {
      filtered = filtered.filter(user => {
        if (!user.roles) {
          return false;
        }
        // Handle roles as array or JSON string
        let roles = user.roles;
        if (typeof roles === 'string') {
          try {
            roles = JSON.parse(roles);
          } catch (e) {
            roles = [roles];
          }
        }
        if (!Array.isArray(roles)) {
          roles = [roles];
        }
        return roles.some((role: string) => role === this.roleFilter);
      });
    }
    
    this.filteredUserList = filtered;
    this.updateDataSource();
  }
  
  clearFilters() {
    this.searchFilter = '';
    this.roleFilter = 'all';
    this.currentPage = 1; // Reset to first page when clearing filters
    this.refreshUsers();
  }
  
  editUser(user: any) {
    this.selectedUser = user;
    this.error = '';
    const property = user.propertyId ? user.propertyId : (user.property && user.property.id ? user.property.id : null);
    this.editForm.patchValue({
      id: user.id,
      firstName: user.firstName,
      lastName: user.lastName,
      email: user.emailAddress,
      role: user.roles ? user.roles[0] : null,
      property: property,
      password: null
    });
    this.previousTabIndex = this.selectedTabIndex;
    this.allowTabChange = true;
    this.selectedTabIndex = 2;
  }
  
  deleteUser(user: any) {
    if (!confirm(`Are you sure you want to delete ${user.firstName} ${user.lastName}?`)) {
      return;
    }
    this.loading = true;
    this.orgService.deleteUser(this.organization, user).then(() => {
      this.refreshUsers();
      if (this.selectedUsers) {
        this.selectedUsers = this.selectedUsers.filter(u => u.id !== user.id);
      }
    }).catch(err => {
      this.error = err.message || 'Unable to delete user';
      this.loading = false;
    });
  }
  
  toggleSelection(user: any) {
    if (!this.selectedUsers) {
      this.selectedUsers = [];
    }
    const index = this.selectedUsers.findIndex(u => u.id === user.id);
    if (index >= 0) {
      this.selectedUsers.splice(index, 1);
    } else {
      this.selectedUsers.push(user);
    }
  }
  
  isSelected(user: any): boolean {
    if (!this.selectedUsers) {
      return false;
    }
    return this.selectedUsers.some(u => u.id === user.id);
  }
  
  toggleAllSelection() {
    if (!this.selectedUsers) {
      this.selectedUsers = [];
    }
    if (this.isAllSelected()) {
      this.selectedUsers = [];
    } else {
      this.selectedUsers = [...(this.filteredUserList || [])];
    }
  }
  
  isAllSelected(): boolean {
    if (!this.filteredUserList || this.filteredUserList.length === 0) {
      return false;
    }
    if (!this.selectedUsers || this.selectedUsers.length === 0) {
      return false;
    }
    return this.selectedUsers.length === this.filteredUserList.length;
  }
  
  isSomeSelected(): boolean {
    if (!this.selectedUsers || this.selectedUsers.length === 0) {
      return false;
    }
    if (!this.filteredUserList || this.filteredUserList.length === 0) {
      return false;
    }
    return this.selectedUsers.length > 0 && this.selectedUsers.length < this.filteredUserList.length;
  }

  private applyUserProperties() {
    if (!this.properties || !this.userList) {
      return;
    }
    for (const u of this.userList) {
      const pid = u.propertyId ? u.propertyId : (u.property && u.property.id ? u.property.id : null);
      if (pid) {
        const prop = this.properties.find(p => p.id === pid);
        if (prop) {
          u.property = prop;
        }
      }
    }
  }

  editSelected(){
    if(!this.selectedUsers || this.selectedUsers.length !== 1){
      this.error = 'Please select exactly one user to edit';
      return;
    }
    this.editUser(this.selectedUsers[0]);
  }

  deleteUsers(){
    if (!confirm('Are you sure you want to delete the selected users?')) {
      return;
    }
    console.log(this.selectedUsers);
    this.loading = true;
    const deletePromises = [];
    for(const user of this.selectedUsers){
      deletePromises.push(this.orgService.deleteUser(this.organization, user));
    }
    Promise.all(deletePromises).then(() => {
      this.selectedUsers = [];
      this.refreshUsers();
    }).catch(err => {
      this.error = err.message || 'Unable to delete user';
      this.loading = false;
    });
  }

  onSubmit(){
    if(this.addressForm.valid) {
      const newUser = {
        emailAddress: this.addressForm.value.email,
        firstName: this.addressForm.value.firstName,
        lastName: this.addressForm.value.lastName,
        password: this.addressForm.value.password,
        roles: [this.addressForm.value.role]
      };

      if(this.addressForm.value.role === 'Leasee') {
        newUser['propertyId'] = this.addressForm.value.property;
      }

      this.orgService.createUser(this.organization, newUser).then(() => {
        this.refreshUsers();
        this.previousTabIndex = this.selectedTabIndex;
        this.allowTabChange = true;
        this.selectedTabIndex = 0;
        this.addressForm.reset();
        this.error = '';
      }).catch(err => {
        this.error = err.message || 'Unable to create user';
      });
    }
  }
  
  cancelCreate() {
    this.addressForm.reset();
    this.error = '';
    this.previousTabIndex = this.selectedTabIndex;
    this.allowTabChange = true;
    this.selectedTabIndex = 0;
  }
  
  goToCreateTab() {
    this.previousTabIndex = this.selectedTabIndex;
    this.allowTabChange = true;
    this.selectedTabIndex = 1;
  }
  
  onTabChange(event: any) {
    // Prevent tab changes by clicking - only allow programmatic changes
    if (!this.allowTabChange) {
      // Revert to previous tab index
      setTimeout(() => {
        this.selectedTabIndex = this.previousTabIndex;
      }, 0);
    } else {
      // Allow the change and update previous index
      this.previousTabIndex = event.index;
      this.allowTabChange = false;
    }
  }

  onEditSubmit(){
    if(this.editForm.valid){
      const updatedUser = {
        id: this.editForm.value.id,
        emailAddress: this.editForm.value.email,
        firstName: this.editForm.value.firstName,
        lastName: this.editForm.value.lastName,
        roles: [this.editForm.value.role],
        password: this.editForm.value.password
      };

      if(this.editForm.value.role === 'Leasee') {
        updatedUser['propertyId'] = this.editForm.value.property;
      }

      if(!updatedUser.password){
        delete updatedUser.password;
      }

      this.orgService.updateUser(this.organization, updatedUser).then(() => {
        this.refreshUsers();
        this.previousTabIndex = this.selectedTabIndex;
        this.allowTabChange = true;
        this.selectedTabIndex = 0;
        this.selectedUsers = [];
        this.selectedUser = null;
        this.error = '';
      }).catch(err => {
        this.error = err.message || 'Unable to update user';
      });
    }
  }
  
  cancelEdit() {
    this.editForm.reset();
    this.selectedUser = null;
    this.error = '';
    this.previousTabIndex = this.selectedTabIndex;
    this.allowTabChange = true;
    this.selectedTabIndex = 0;
  }

  close() {
    this.router.navigate(['/admin-landing']);
  }

  onRowClick(event: MouseEvent, user: any) {
    // Prevent row click from triggering when clicking on action buttons
    const target = event.target as HTMLElement;
    if (target.closest('button') || target.closest('mat-checkbox')) {
      return;
    }
    // Select user for editing when row is clicked
    this.toggleSelection(user);
  }

}
